const FILTER_BY_STOCK = "FILTER_BY_STOCK";
const FILTER_BY_DELIVERY = "FILTER_BY_DELIVERY";
const FILTER_BY_PRICE_RANGE = "FILTER_BY_PRICE_RANGE";
const FILTER_BY_CATEGORY = "FILTER_BY_CATEGORY";
const FILTER_BY_RATING = "FILTER_BY_RATING";
const FILTER_BY_BRANDNAME = "FILTER_BY_BRANDNAME";
const SORT_BY = "SORT_BY";
const SEARCH = "SEARCH";
const CLEAR_ALL = "CLEAR_ALL";

export {
  FILTER_BY_STOCK,
  FILTER_BY_DELIVERY,
  FILTER_BY_PRICE_RANGE,
  FILTER_BY_CATEGORY,
  FILTER_BY_RATING,
  FILTER_BY_BRANDNAME,
  SORT_BY,
  SEARCH,
  CLEAR_ALL,
};
